<ng-container [formGroup]="formGroup">
  <form-field dialog label="global.color">
    <div any class="flex f-1 flex-row align-center">
      <color-picker any class="f-0 mr10" for="color"></color-picker>
    </div>
  </form-field>
</ng-container>